import React, { DragEvent } from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function DropZone(props: Props) {
  const ref = React.useRef<HTMLDivElement>(null);
  const dropZone = ref.current;

  React.useEffect(() => {
    const dragOver = (e: DragEvent | any) => {
      e.preventDefault();

      dropZone && dropZone.classList.add(styles.droppable);
    };
    const dragLeave = () =>
      dropZone && dropZone.classList.remove(styles.droppable);
    const drop = (e: DragEvent | any) => {
      e.preventDefault();

      const files = e.dataTransfer ? e.dataTransfer.files : [];

      dropZone && dropZone.classList.remove(styles.droppable);
      !!files[0] &&
        props.drop({
          name: files[0].name,
          size: files[0].size,
          type: files[0].type,
          uri: URL.createObjectURL(files[0]),
        });
    };

    if (dropZone) {
      dropZone.addEventListener("dragover", dragOver);
      dropZone.addEventListener("dragleave", dragLeave);
      dropZone.addEventListener("drop", drop);
    }

    return () => {
      if (dropZone) {
        dropZone.removeEventListener("dragover", dragOver);
        dropZone.removeEventListener("dragleave", dragLeave);
        dropZone.removeEventListener("drop", drop);
      }
    };
  }, [dropZone, props.drop]);

  return (
    <div ref={ref} className={classNames(styles.dropZone, props.className)}>
      {props.children}
    </div>
  );
}

export { DropZone };
